import { Component, OnInit, ɵConsole } from '@angular/core';
import { HttpClient, HttpHandler, HttpHeaders } from '@angular/common/http';
import * as moment from 'moment';
import { ToastService } from 'ng-zorro-antd-mobile';
import { DashboardService } from '../service/dashboard/dashboard.service';
import { Router } from '@angular/router';
import { Options } from 'selenium-webdriver';
@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css']
})
export class HomepageComponent implements OnInit {
  configList = {}
  quitReason = {}
  dataSample = {
    cname: '',
    emplid: '',
    idcard: '',
    phonenum: '',
    empDept: '',
    empRequire: '',
    hopeQuitdate: '',
    quitReason: '',
    reasonType: '',
    comment: '',
    isInterviewed: '',
    talkerId:'',
    talkerName:'',
  };
  submit_disabled = false;
  value = '';
  // tips1 = '请选择';
  tips2 = '请选择';
  tips3 = '请选择';
  tips4 = '请选择';
  tips5 = '请选择';
  tips6 = '请选择';
  tips7 = '请选择';
  tips8 = '请选择';
  canSelectDateList = [];
  notice_info = [];
  isInterviewedList = [];
  fiveDepartments = [];
  noOneOrTwo = "";
  log = {
    logdate: moment.now(),
    data: 'any'
  }
  comment = '';
  emplyInfo = {};
  constructor(
    private http: HttpClient,
    private _toast: ToastService,
    private dashboardService: DashboardService,
    private router: Router,
  ) { }

  async ngOnInit() {
    this.configList = await this.http.get('./assets/config/remindText.json').toPromise();
    //let headers:HttpHeaders=new  HttpHeaders();
    //headers.set("Authorization","Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJEMTExMTEiLCJyb2xlIjoiW3tcImNvbXBhbnlJZFwiOjIsXCJpZFwiOjEsXCJyZW1hcmtcIjpcIui2hee6p-euoeeQhuWRmFwiLFwicm9sZW5hbWVcIjpcInN1cGVyQWRtaW5cIn1dIiwiY29tcGFueSI6Ilt7XCJjb21wYW55TmFtZVwiOlwid2JcIixcImlkXCI6MixcImlzQ2xvdWRcIjoxfV0iLCJleHAiOjE2NDY1MzI4Nzd9.sgG1pRpofIm1t_aCr6SU6UpzJfHhGKMwGN8d76RbSbM")
    //this.configList = await this.http.post('http://10.62.22.40:7080/pvpower/histroy/getLogId?stationCode=A48C30B052664EDCA74D25BDF5B8EDCA',{headers:headers}).toPromise();
    this.notice_info = this.configList['noticeInfo'];
    this.isInterviewedList = this.configList['isInterviewed'];
    this.comment = this.configList['comment'][this.configList['comment'].length-1];
    this.fiveDepartments =  this.configList['fiveDepartments'];
    this.noOneOrTwo =  this.configList['noOneOrTwo'];
    this.getCanSelectDate();
  }

  // getDept(result) {
  //   this.tips1 = this.getResult(result);
  // }
  getRequire(result) {
    this.tips2 = this.getResult(result);
  }
  getQuitDate(result) {
    this.tips3 = this.getResult1(result);
  }
  getReasonType(result) {
    this.tips4 = this.getResult2(result);
    for (let i = 0; i < this.configList['quitReason'].length; i++) {
      const element = this.configList['quitReason'][i];
      if(element['label'] == result[1]){
        this.quitReason = [element]
      }
    }
    this.tips6='请选择'
    this.dataSample['quitReason'] = ''
  }
  getQuitReason(result) {
    this.tips5 = this.getResult(result);
  }
  getReasonDetail(result) {
    this.tips6 = this.getResult2(result);
    if (this.tips6 == '其他-其他（请填写具体事项）') {
      this.dataSample['quitReason'] = '';
    }
  }
  async filterSearch() {
    //判断员工工号是否存在
    if (this.dataSample['emplid'].toUpperCase()) {
      // 输入工号后光标移动->判断工号是否存在：存在则带出姓名和部门(WCD&WCQ同步)
      const list = await this.dashboardService.getEmplist(this.dataSample['emplid'].toUpperCase()).toPromise();
      if (!list.length) {
        // 如果获取的姓名和部门为空，清空列表->提示'您输入的工号不正确'(WCD&WCQ同步)
        this.emplyInfo = {};
        this.dataSample = {
          cname: '',
          emplid: '',
          idcard: '',
          phonenum: '',
          empDept: '',
          empRequire: '',
          hopeQuitdate: '',
          quitReason: '',
          reasonType: '',
          comment: '',
          isInterviewed: '',
          talkerId:'',
          talkerName:'',
        };
        this.tips2 = '请选择';
        this.tips3 = '请选择';
        this.tips4 = '请选择';
        this.tips5 = '请选择';
        this.tips6 = '请选择';
        this.tips7 = '请选择';
        this.tips8 = '请选择';
        this._toast.fail('您输入的工号不正确', 2500);
      } else if ((this.fiveDepartments.indexOf((list[0].deptid).slice(0, 4)+'00') == -1) && (this.configList["site"] === "WCD")) {
        // 如果工号获取的部门不在五大厂范围内，清空列表并提示(WCQ)
        this.emplyInfo = {};
        this.dataSample = {
          cname: '',
          emplid: '',
          idcard: '',
          phonenum: '',
          empDept: '',
          empRequire: '',
          hopeQuitdate: '',
          quitReason: '',
          reasonType: '',
          comment: '',
          isInterviewed: '',
          talkerId:'',
          talkerName:'',
        };
        this.tips2 = '请选择';
        this.tips3 = '请选择';
        this.tips4 = '请选择';
        this.tips5 = '请选择';
        this.tips6 = '请选择';
        this.tips7 = '请选择';
        this.tips8 = '请选择';
        this._toast.fail(`${this.noOneOrTwo}`, 2500);
      } else {
        this.emplyInfo = list[0];
        this.dataSample['empDept'] = list[0]['deptid'];
        this.dataSample['cname'] = list[0]['cname'];
      }
    }
  }
  async filterSearchTalker(){
    //判断访谈者工号是否存在
    if(this.dataSample['talkerId'].toUpperCase()){
      // 输入工号后光标移动->判断工号是否存在：存在则带出姓名和部门(WCD&WCQ同步)
      const list = await this.dashboardService.getEmplist(this.dataSample['talkerId'].toUpperCase()).toPromise();
      console.log("list2:",list);

      if (!list.length) {
        // 如果获取的姓名和部门为空，清空列表->提示'您输入的工号不正确'(WCD&WCQ同步)
        this.emplyInfo = {};
        this.dataSample['talkerId']='';
        this.dataSample['talkerName']='';
        this._toast.fail('您输入的工号不正确', 2500);
      }else{
        this.dataSample['talkerName']=list[0]['cname'];
        console.log("this.dataSample['talkerName']:",this.dataSample['talkerName']);
      }
    }
  }

  getComment(result) {
    this.tips7 = this.getResult(result);
    if (this.tips7 == this.comment) {
      this.dataSample['comment'] = '';
    }
  }
  getIsReview(result){
    this.tips8 = this.getResult2(result);
  }
  getResult(result) {
    this.value = '';
    result.forEach(item => {
      this.value = item.label || item;
    });
    return this.value;
  }
  getResult1(result) {
    var value = [];
    var selectResult = [];
    var elementStr = '';
    result.forEach(item => {
      value.push( item.label || item );
    });
    for (const item of value) {
      const element = parseInt(item);
      if (element <= 9) {
        elementStr = '0' + element;
      }else {
        elementStr = element.toString();
      }
      selectResult.push(elementStr);
    }
    return selectResult.map(v => v).join('-');
  }
  getResult2(result) {
    let value = [];
    let temp = '';
    result.forEach(item => {
      value.push(item.label || item);
      temp += item.label || item;
    });
    return value.map(v => v).join('-');
  }

  getCanSelectDate() {
    const isPostponeList = this.configList['isPostpone'];
    const postponeDay = this.configList['postponeDay'];
    const noPostponeDay = this.configList['noPostponeDay'];
    const now = new Date();
    // const now = new Date('2021-01-01 06:00:00');
    // const cday = (now.getDay() == 5 || now.getDay() == 6 || now.getDay() == 0) ? 4 : 2;
    const cday = isPostponeList.includes(now.getDay()) ? postponeDay : noPostponeDay;
    const addNow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + cday);
    // 三天后是星期几
    const addDay = addNow.getDay();
    const endDate = new Date(addNow.getFullYear() + Number(this.configList['yearRange']), now.getMonth(), now.getDate());
    let copyDate = addNow;
    let i = 0;
    const allDate = {};
    while (copyDate < endDate) {
      const day2 = 2 + 7 * i ;
      const day4 = 4 + 7 * i ;
      const xinqi2 = new Date(addNow.getFullYear(), addNow.getMonth(), addNow.getDate() + day2 - addDay );
      const xinqi4 = new Date(addNow.getFullYear(), addNow.getMonth(), addNow.getDate() + day4 - addDay );
      if (xinqi2 > addNow) {
        if (!allDate[xinqi2.getFullYear()]) {
          allDate[xinqi2.getFullYear()] = {};
        }
        if (!allDate[xinqi2.getFullYear()][xinqi2.getMonth() + 1]) {
          allDate[xinqi2.getFullYear()][xinqi2.getMonth() + 1] = [];
        }
        if(this.configList["site"] != "WCQ" || this.configList["site"] != "WCD"){
          if(xinqi2.getDate() < 26) {
            allDate[xinqi2.getFullYear()][xinqi2.getMonth() + 1].push(xinqi2.getDate());
          }
        }else{
          allDate[xinqi2.getFullYear()][xinqi2.getMonth() + 1].push(xinqi2.getDate());
        }
      }
      if (xinqi4 > addNow) {
        if (!allDate[xinqi4.getFullYear()]) {
          allDate[xinqi4.getFullYear()] = {};
        }
        if (!allDate[xinqi4.getFullYear()][xinqi4.getMonth() + 1]) {
          allDate[xinqi4.getFullYear()][xinqi4.getMonth() + 1] = [];
        }
        if (this.configList["site"] != "WCQ" || this.configList["site"] != "WCD") {
          if(xinqi4.getDate() < 26) {
            allDate[xinqi4.getFullYear()][xinqi4.getMonth() + 1].push(xinqi4.getDate());
          }
        }else{
          allDate[xinqi4.getFullYear()][xinqi4.getMonth() + 1].push(xinqi4.getDate());
        }
      }
      copyDate = xinqi4;
      i++;
    }
    for (const keyYear in allDate) {
      if (Object.prototype.hasOwnProperty.call(allDate, keyYear)) {
        var itemYear = {
          label: keyYear + '年',
          children: []
        }
        for (const keyMonth in allDate[keyYear]) {
          if (Object.prototype.hasOwnProperty.call(allDate[keyYear], keyMonth)) {
            const itemMonth = {
              label: keyMonth + '月',
              children: []
            }
            if(allDate[keyYear][keyMonth].length != 0) {
              for (const keyDay in allDate[keyYear][keyMonth]) {
                if (Object.prototype.hasOwnProperty.call(allDate[keyYear][keyMonth], keyDay)) {
                  itemMonth['children'].push(allDate[keyYear][keyMonth][keyDay] + '日');
                }
              }
              itemYear['children'].push(itemMonth);
            }
          }
        }
      }
      this.canSelectDateList.push(itemYear);
    }
    for (const item of this.canSelectDateList) {
      if (item.children.length == 0) {
        this.canSelectDateList.splice(item,1);
      }
    }
  }
  async submitData() {
    try{
      this.submit_disabled = true;
    //   if(!this.emplyInfo['emplid'].toUpperCase()){
    //      this._toast.fail('您输入的工号不正确');
    //      this.submit_disabled = false;
    //      return;
    //  }
      const saveData = {
        site: this.configList["site"],
        emptype: 'DL',
        cname: this.dataSample.cname,
        emplid: this.dataSample.emplid.toUpperCase(),
        idcard: this.dataSample.idcard.replace(/\s/g, ''),
        phonenum: this.dataSample.phonenum.replace(/\s/g, ''),
        empDept: this.dataSample.empDept,
        empRequire: this.dataSample.empRequire[0],
        hopeQuitdate: this.dataSample.empRequire[0] == '撤销申请' ? '' : this.dataSample.hopeQuitdate,
        quitReason: this.dataSample.empRequire[0] == '撤销申请' ? this.dataSample.quitReason[0] : this.dataSample.quitReason,
        reasonType: this.dataSample.empRequire[0] == '撤销申请' ? '' : this.dataSample.reasonType,
        comment: this.dataSample.empRequire[0] == '撤销申请' ? '' : this.dataSample.comment[0],
        isInterviewed: this.dataSample.isInterviewed,
        insertDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss')+"Z",
      }
      if(this.dataSample['empRequire'] == '撤销申请' && this.dataSample['isInterviewed'][0] != null && this.dataSample['isInterviewed'][0]['label'] == '是'){
        saveData['talkerId'] = this.dataSample.talkerId
        saveData['talkerName'] = this.dataSample.talkerName
      }
      for (const key in saveData) {
        if (Object.prototype.hasOwnProperty.call(saveData, key)) {
          const element = saveData[key];
          let emptyName = '';
          if (saveData['empRequire'] && saveData['empRequire'] == '撤销申请') {
            if (key!= 'hopeQuitdate' && key!= 'reasonType' && key!= 'comment') {
              if (!element) {
                for (const item of this.notice_info) {
                  if (item.prop == key) {
                    if (item.prop == 'quitReason') {
                      emptyName = '撤销离职的原因'
                    }
                    else if(item.prop == 'talkerId'){
                      emptyName = '访谈人员工号'
                    }else if(item.prop == 'talkerName'){
                      emptyName = '访谈人员姓名'
                    }
                    else{
                      emptyName = item.label;
                    }
                  }
                }
                this._toast.fail(`${emptyName}不能为空，请填写完整!!!`, 2000);
                this.submit_disabled = false;
                return;
              }
            }
          }else {
            if (!element) {
              for (const item of this.notice_info) {
                if (item.prop == key) {
                  emptyName = item.label;
                }
              }
              this._toast.fail(`${emptyName}不能为空，请填写完整!!!`, 2000);
              this.submit_disabled = false;
              return;
            }
          }
        }
      }
      if(saveData['phonenum'].length != 11) {
        this._toast.fail('手机号码必须为11位!!!', 2000);
        this.submit_disabled = false;
        return;
      }
      if(saveData['idcard'].length != 18) {
        this._toast.fail('身份证号码必须为18位!!!', 2000);
        this.submit_disabled = false;
        return;
      }
      if(!!saveData['reasonType']) {
        for (const item of saveData['reasonType']) {
          if (item['label']) {
            saveData['reasonType'] = item['label'] + saveData['reasonType'][saveData['reasonType'].length-1];
          }
        }
      }
      if(!!saveData['quitReason']) {
        for (const item of saveData['quitReason']) {
          if (item['label']) {
            saveData['quitReason'] = item['label'] + saveData['quitReason'][saveData['quitReason'].length-1];
          }
        }
      }
      if(!!saveData['isInterviewed']) {
        for (const item of saveData['isInterviewed']) {
          if (item['label']) {
            saveData['isInterviewed'] = item['label'] + '-' + saveData['isInterviewed'][saveData['isInterviewed'].length-1];
          }
        }
      }
      if(!!saveData['hopeQuitdate']) {
        var str = '';
        var elementStr = '';
        var lastElement = parseInt(saveData['hopeQuitdate'][saveData['hopeQuitdate'].length-1]);
        var lastElementStr = '';
        for (let i = 0; i < saveData['hopeQuitdate'].length; i++) {
          if(saveData['hopeQuitdate'][i]['label']) {
            const element = parseInt(saveData['hopeQuitdate'][i]['label']);
            if (element <= 9) {
              elementStr = '0' + element;
            }else {
              elementStr = element.toString();
            }
            str += elementStr + '-';
          }
        }
        if(lastElement <= 9) {
          lastElementStr = '0' + lastElement;
        } else {
          lastElementStr = lastElement.toString();
        }
        saveData['hopeQuitdate'] = str + lastElementStr;
      }
      await this.dashboardService.addRecord(saveData).toPromise();
      // if (this.configList["site"]==='WCQ') {
      //   this._toast.success(`${this.resultTip2}`,3500);
      // }
      this._toast.fail(`${this.configList['revokeApply']}`, 5000);
      this.submit_disabled = false;
      this.router.navigateByUrl('/resultpage');
    }catch(error){
      this.sendlog(error);
      console.log(error);
      this._toast.fail(`提交失败:${JSON.stringify(error)}`, 2000);
      this.submit_disabled = false;
    }
  }
  sendlog(data){
    this.log.logdate=moment.now();
    this.log.data=data;
    // this.dashboardService.postlog(this.log).toPromise();
  }
}
